import { getUserMentionLabel } from '#pplx/frontend/apps/ask/user-mentions/getUserMentionLabel.js';
import { getUserMentionTarget } from '#pplx/frontend/apps/ask/user-mentions/userMentionUrl.js';
export function getSubmittedMentionedUsers(mentions, currentUserEmail) {
    const submittedMentions = mentions ?? [];
    const usersByOrgUserUUID = submittedMentions.reduce((usersByOrgUserUUID, mention) => {
        if (mention.type !== 'user') {
            return usersByOrgUserUUID;
        }
        const target = getUserMentionTarget(mention.url);
        if (!target || target.email.toLowerCase() === currentUserEmail) {
            return usersByOrgUserUUID;
        }
        usersByOrgUserUUID.set(mention.id, {
            displayLabel: getUserMentionLabel(null, target.email),
            orgUserUUID: mention.id,
        });
        return usersByOrgUserUUID;
    }, new Map());
    return [...usersByOrgUserUUID.values()];
}
//# sourceMappingURL=getSubmittedMentionedUsers.js.map